import Table from "../table/Table"
import Breadcrumbs from "../../coreComponents/breadcrumbs"
import CommonCardHeader from "../../coreComponents/CommonCardHeader"
import { useAppSelector } from "../../reduxToolkit/hooks"
import { useCallback, useEffect, useState } from "react"
import { usePagination } from "../../hooks/usePagination"
import FilterIcon from "../svg/FilterIcon"
import { Button, Card, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { useNavigate } from "react-router-dom"
import LoadingComponent from "../lodingComponent"
import LeftIcon from "../svg/LeftButton"
import RightIcon from "../svg/RightIcon"
import ApiService from "../../services/apiService"
import { method } from "lodash"
import { toast } from "react-toastify"
import { format } from "date-fns"
import DateTimePicker from 'react-datepicker'
const PowerConsumption = () => {

    const role = useAppSelector((state: any)  => state.role.role);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
    const navigate = useNavigate();
    const [selectedId,setSelectedId] = useState<string|number>()
    const [isEnabled, setIsEnabled] = useState<boolean>(false)
    const [fromDateTime, setFromDateTime] = useState(null);
    const [toDateTime, setToDateTime] = useState(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
  
    const [selectedStationName,setSelectedStationName] = useState<string>();
    const [pumpingStationData, setpumpingStationData] = useState<any>([]);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);



    useEffect(() => {
        const getPumpingStation = async () => {
            try {
                const response = await ApiService.axiosApi(`/pumpingstation`, {
                    method: 'GET',
                    params: {
                        pageNumber: 0,
                        pageSize: 0
                    }
                })
                if (response.success) {
                    setpumpingStationData(response.data.data)
                } else {
                    console.log(response.status || response.message || "Unable to get Pumping Station")
                }
            } catch (error) {
                console.log(error)
            }
        }

        getPumpingStation();
    }, [])

    
    const {
        data,
        pageNumber, setPageNumber,
        pageSize, totalCount,
        setRefresh, searchQuery,
        setSearchQuery, filterOn,
        setSortBy, loading,
        setPumpingStationId,
        setFromDate,setToDate
    } = usePagination({
        endpoint: `/pumpingstation/dailypowerconsumption`,
        enabled: isEnabled
    })

    const totalPages = Math.ceil(totalCount / pageSize);

    const handleNext = useCallback(() => {
        setPageNumber((prev) => Math.min(totalPages, prev + 1))
    }, [setPageNumber, totalPages])



    const handlePrev = useCallback(() => {
        setPageNumber((prev) => Math.max(1, prev - 1))
    }, [setPageNumber, totalPages])

    

    const validateGenerate = () => {
        if (!selectedStationName) {
          toast.warning("Please select Station");
          return false;
        }
      
        
        if (!fromDateTime) {
          toast.warning("Please select From Date");
          return false;
        }
      
        if (!toDateTime) {
          toast.warning("Please select To Date");
          return false;
        }
      
        if (new Date(fromDateTime) > new Date(toDateTime)) {
          toast.warning("From Date cannot be greater than To Date");
          return false;
        }
      
        return true;
      };


   

    const handleClick = () =>{

        if (!validateGenerate()) return;

        if (fromDateTime) {
            const from = format(fromDateTime, 'yyyy-MM-dd HH:mm:ss');
            setFromDate(from);
        }

        if (toDateTime) {
            const to = format(toDateTime, 'yyyy-MM-dd HH:mm:ss');
            setToDate(to)
        }

        setIsEnabled(true)
        setRefresh(prev => !prev)
    }

    let updatedData
      if(data){
           updatedData = data.map((data)=>{
              return{
                 ...data,
                 dateTime:format(new Date(data.dateTime),'dd-MM-yyyy HH:mm:ss')
              }
         })
      }

    
    return (
        <>
              <Breadcrumbs mainTitle="Power Consumption" parent="Power Consumption" />
              <div className='w-100 bg-white px-2 py-2'>
                <div className='bg-light-primary d-flex justify-content-around align-items-center'
                    style={{
                        width: '100%',
                        height: '100px',
                        border: '1px solid rgb(43, 94, 94, 0.1)',
                    }}>

                    <div className="d-flex flex-column">
                        <Label>Pumping Station:</Label>

                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className="custom-dropdown-wrapper">
                            <DropdownToggle
                                className="custom-dropdown-toggle d-flex align-items-center justify-content-between report-dropdown"

                                style={{
                                    
                                    fontWeight: 500,
                                    borderRadius: '5px',
                                    padding: '8px 16px',
                                    width: '200px',
                                    height:'36px'
                                }}
                                color="whitesmoke"
                            >
                                {selectedStationName ? selectedStationName : "Pumping Station"}
                            </DropdownToggle>

                            <DropdownMenu
                                className="custom-dropdown-menu"
                                style={{

                                    overflowY: 'auto',
                                    boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.1)',
                                    borderRadius: '8px',
                                    padding: '8px 0',
                                    width: '200px'
                                }}
                            >
                                {pumpingStationData?.map((data: any) => (
                                    <DropdownItem onClick={() => {
                                        
                                        setSelectedStationName(data.name)
                                    }} key={data.id}>
                                        {data.name}
                                    </DropdownItem>
                                ))}
                            </DropdownMenu>
                        </Dropdown>

                    </div>

                    <div className="report-input-div mx-4 input-border d-flex flex-column ">
                        <Label>From Date:</Label>
                        <DateTimePicker
                            className="report-input"
                            dateFormat="dd/MM/yyyy HH:mm:ss"
                            placeholderText="DD-MM-YYYY"
                            showTimeSelect
                            onChange={(date: any) => setFromDateTime(date)}
                            selected={fromDateTime}
                            isClearable
                            timeFormat="HH:mm:ss"
                        />
                    </div>


                    <div className="report-input-div mx-4  input-border  d-flex flex-column">
                        <Label>To Date:</Label>
                        <DateTimePicker
                            className="report-input"
                            dateFormat="dd/MM/yyyy HH:mm:ss"
                            placeholderText="DD-MM-YYYY"
                            showTimeSelect
                            onChange={(date: any) => setToDateTime(date)}
                            selected={toDateTime}
                            isClearable
                            timeFormat="HH:mm:ss"
                        />
                    </div>

                    <div className=" d-flex flex-column">
                        <Label style={{visibility:'hidden'}}>Generate</Label>
                        <Button color="success" onClick={handleClick}>
                            Generate
                        </Button>
                    </div>

                    

                </div>

                


                <div className='mt-2'>
                    <Table
                        isAction={false}
                        data={updatedData}
                        columns={[
                            { header: 'Date&Time', accessor: 'dateTime' },
                            { header: 'Power Consumption(kWh)', accessor: 'powerConsumption' },
                            
                        ]}

                        buttons={[
                            
                        ]}
                    />
                </div>

                <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
                <p style={{ marginRight: '10px', marginTop: '8px' }}>
                    Page {pageNumber} of {totalPages}
                </p>
                <button
                    onClick={handlePrev}
                    disabled={pageNumber === 1}
                    className={`icon-button ${pageNumber === totalPages ? `icon-button` : ''}`}
                >
                    <LeftIcon className="icon" />
                </button>
                <button
                    className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                    onClick={handleNext}
                    disabled={pageNumber === totalPages}
                >
                    <RightIcon className="icon" />
                </button>
            </div>
                


                
            </div>
             
           {/* <Card>

            
            
            <div className="d-flex justify-content-between">
                <div style={{ marginLeft: '10px' }} className="align-items-centre flex-row d-flex">
                    <div>
                        <input
                            type="text"
                            className="search-input"
                            placeholder="...search"
                            value={searchQuery}
                            onChange={(e) => {
                                setSearchQuery(e.target.value)
                                setPageNumber(1)
                            }}

                        />
                    </div>
                    <div>
                        <button className="filter-button mx-2 p-1" style={{ height: '30px' }} onClick={() => setSortBy('ChackName')}>
                            <FilterIcon />
                        </button>
                    </div>

                </div>
                {role === "Administrator" && (
                    <div className="d-flex justify-content-end " >
                        <Button onClick={() => navigate(`/power-consumption-add`)} color="primary" className="mb-2 mx-2">Add Chak</Button>
                    </div>
                )}
            </div>

            {
                loading ? <LoadingComponent /> : <Table
                    data={data}
                    columns={[
                        { header: "Pumping Station", accessor: 'name' },
                        { header: 'Power Consumption(kWh)', accessor: 'powerConsumption_KWH' },
                        { header: 'Date&Time', accessor: 'dateTime' }
                    ]}

                    buttons={[
                        { label: 'Edit', onClick: handleUpdate, color: 'primary', className: 'me-2' },
                        { label: 'Delete', onClick: handleDelete, color:"danger" }
                    ]}
                />

            }

            <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
                <p style={{ marginRight: '10px', marginTop: '8px' }}>
                    Page {pageNumber} of {totalPages}
                </p>
                <button
                    onClick={handlePrev}
                    disabled={pageNumber === 1}
                    className={`icon-button ${pageNumber === totalPages ? `icon-button` : ''}`}
                >
                    <LeftIcon className="icon" />
                </button>
                <button
                    className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                    onClick={handleNext}
                    disabled={pageNumber === totalPages}
                >
                    <RightIcon className="icon" />
                </button>
            </div>
              
              <Modal isOpen={isModalOpen} toggle={()=>setIsModalOpen(!isModalOpen)}>
                 <ModalHeader>
                    <h3>   
                         Delete Power Consumption
                    </h3>
                 </ModalHeader>
                 <ModalBody>
                     <h5>Are You Sure You Want This Power Consumption</h5>
                 </ModalBody>
                 <ModalFooter>
                     <Button onClick={()=>{handleDeleteConfirm(selectedId)}} color="danger">
                        Delete
                     </Button>
                     <Button onClick={()=>setIsModalOpen(false)} color="primary"> 
                        Cancel
                     </Button>
                 </ModalFooter>
              </Modal>

            </Card>*/}

        </>
    )
}

export default PowerConsumption